<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "../components/loader";
import Multiselect from '@vueform/multiselect'
import api from "@/axios";
import {getBaseUrl} from "@/helpers/baseUrl";


export default {
  page: {
    title: "Pagamento",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Multiselect, Layout, PageHeader, Loader },
  data() {
    return {
      updating: true,
      activeTab: 0,
      title: "Pagamento",
      items: [
        {
          text: "Comercial",
          href: "/",
        },
        {
          text: "Pagamento",
          active: true,
        },
      ],
      stateValue: null,
      countryValue: null,
      stateOptions: [
        "Alaska",
        "Hawaii",
        "California",
        "Nevada",
        "Oregon",
        "Washington",
        "Arizona",
        "Colorado",
        "Idaho",
        "Montana",
        "Nebraska",
        "New Mexico",
        "North Dakota",
        "Utah",
        "Wyoming",
        "Alabama",
        "Arkansas",
        "Illinois",
        "Iowa",
      ],
      countryOptions: [
        "Afghanistan",
        "Albania",
        "Algeria",
        "American Samoa",
        "Andorra",
        "Angola",
        "Anguilla",
        "Antarctica",
        "Argentina",
        "Hawaii",
        "California",
        "Colombia",
        "Congo",
        "Dominica",
        "Denmark",
        "Nevada",
        "Oregon",
        "Washington",
        "Ecuador",
        "Idaho",
        "Montana",
        "Namibia",
        "Nauru",
        "Nepal",
        "Netherlands",
        "Nicaragua",
        "New Caledonia",
        "North Dakota",
        "Tonga",
        "Tunisia",
        "Thailand",
        "Turkey",
        "Illinois",
        "Tuvalu",
        "Uganda",
        "Uruguay",
        "United Arab Emirates",
        "United Kingdom",
        "Venezuela",
        "Zimbabwe",
        "Uruguay",
      ],
    };
  },

  mounted() {
    this.totalRows = this.items.length;
    api.get(`${getBaseUrl()}api/testarapi`).then((res) => {
      console.log('then axios')
      console.log(res)
      this.updating = false
    });
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <div class="checkout-tabs" v-if="!updating">
      <b-tabs
          v-model="activeTab"
          pills
          vertical
          nav-class="p-0"
          nav-wrapper-class="col-xl-2 col-sm-3"
          content-class="w-100"
      >
        <b-tab active>
          <template v-slot:title>
            <i class="bx bxs-truck d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">Entrega</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <h4 class="card-title">Informações de Entrega</h4>
<!--                <p class="card-title-desc">Favor preencher corretamente os campos abaixo</p>-->
                <form>
                  <b-row class="mb-4">
                    <b-col md="2">
                      <label for="input-name">Nome</label>
                    </b-col>
                    <b-col md="10">
                      <b-form-input
                          id="input-name"
                          placeholder="Entre com seu nome"
                      ></b-form-input>
                    </b-col>
                  </b-row>

                  <b-row class="mb-4">
                    <b-col md="2">
                      <label for="billing-email-address">Endereço de Email</label>
                    </b-col>
                    <b-col md="10">
                      <b-form-input
                          id="billing-email-address"
                          placeholder="Entre com seu email"
                      ></b-form-input>
                    </b-col>
                  </b-row>

                  <b-row class="mb-4">
                    <b-col md="2">
                      <label for="billing-phone">Telefone</label>
                    </b-col>
                    <b-col md="10">
                      <b-form-input
                          id="billing-phone"
                          placeholder="Entre com seu telefone"
                      ></b-form-input>
                    </b-col>
                  </b-row>

                  <b-row class="mb-4">
                    <b-col md="2">
                      <label for="billing-address">Endereço</label>
                    </b-col>
                    <b-col md="10">
                      <b-form-textarea
                          id="billing-address"
                          rows="3"
                          placeholder="Entre com seu endereço completo"
                      ></b-form-textarea>
                    </b-col>
                  </b-row>

                  <div class="form-group row mb-4">
                    <span class="col-md-2 col-form-label">Cidade</span>
                    <div class="col-md-10">
                      <multiselect
                          v-model="countryValue"
                          :options="countryOptions"
                      ></multiselect>
                    </div>
                  </div>

                  <div class="form-group row mb-4">
                    <span class="col-md-2 col-form-label">Estado</span>
                    <div class="col-md-10">
                      <multiselect
                          v-model="stateValue"
                          :options="stateOptions"
                      ></multiselect>
                    </div>
                  </div>
                  <b-row class="mb-4">
                    <b-col md="2">
                      <label for="example-textarea">Observações</label>
                    </b-col>
                    <b-col md="10">
                      <b-form-textarea
                          id="example-textarea"
                          rows="3"
                          placeholder="Entre com observações referente a seu pedido..."
                      ></b-form-textarea>
                    </b-col>
                  </b-row>
                </form>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-6">
                <button
                    @click="$router.go(-1)"
                    class="btn text-muted d-none d-sm-inline-block btn-link"
                >
                  <i class="mdi mdi-arrow-left me-1"></i> Voltar
                </button>
              </div>
              <!-- end col -->
              <div class="col-sm-6">
                <div class="text-end">
                  <button
                      @click="activeTab = 1"
                      class="btn btn-success"
                  >
                    <i class="mdi mdi-arrow-right me-1"></i> Avançar para Pagamento
                  </button>
                </div>
              </div>
              <!-- end col -->
            </div>
          </b-card-text>
        </b-tab>
        <b-tab>
          <template v-slot:title>
            <i class="bx bx-money d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">Pagamento</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div>
                  <h4 class="card-title">Informações de Entrega</h4>
<!--                  <p class="card-title-desc">Favor preencher corretamente os campos abaixo</p>-->

                  <div>
                    <div class="form-check form-check-inline font-size-16">
                      <input
                          class="form-check-input"
                          type="radio"
                          name="paymentoptionsRadio"
                          id="paymentoptionsRadio1"
                          checked=""
                      />
                      <label
                          class="form-check-label font-size-13"
                          for="paymentoptionsRadio1"
                      ><i
                          class="fab fa-cc-mastercard me-1 font-size-20 align-top"
                      ></i>
                        Cartão de Crédito</label
                      >
                    </div>

                    <div class="form-check form-check-inline font-size-16">
                      <input
                          class="form-check-input"
                          type="radio"
                          name="paymentoptionsRadio"
                          id="paymentoptionsRadio2"
                          disabled
                      />
                      <label
                          class="form-check-label font-size-13"
                          for="paymentoptionsRadio2"
                      ><i
                          class="fab fa-cc-paypal me-1 font-size-20 align-top"
                      ></i>
                        Paypal</label
                      >
                    </div>

                    <div class="form-check form-check-inline font-size-16">
                      <input
                          class="form-check-input"
                          type="radio"
                          name="paymentoptionsRadio"
                          id="paymentoptionsRadio3"
                          disabled
                      />
                      <label
                          class="form-check-label font-size-13"
                          for="paymentoptionsRadio3"
                      ><i
                          class="far fa-money-bill-alt me-1 font-size-20 align-top"
                      ></i>
                        PIX</label
                      >
                    </div>
                  </div>

                  <h5 class="mt-5 mb-3 font-size-15">Informações do cartão</h5>
                  <div class="p-4 border">
                    <form>
                      <b-form-group
                          id="input-group-2"
                          label="Número do Cartão"
                          label-for="input-card"
                          class="mb-0"
                      >
                        <b-form-input
                            id="input-card"
                            placeholder="0000 0000 0000 0000"
                        ></b-form-input>
                      </b-form-group>

                      <b-row class="mt-4">
                        <b-col lg="6">
                          <b-form-group
                              id="input-group-2"
                              label="Nome"
                              label-for="input-number"
                              class="mb-0"
                          >
                            <b-form-input
                                id="input-number"
                                placeholder="Nome"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                        <b-col lg="3">
                          <b-form-group
                              id="input-group-2"
                              label="Vencimento"
                              label-for="input-date"
                              class="mb-0"
                          >
                            <b-form-input
                                id="input-date"
                                placeholder="MM/AA"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>

                        <b-col lg="3">
                          <b-form-group
                              id="input-group-2"
                              label="CVV"
                              label-for="cvvcodeInput"
                              class="mb-0"
                          >
                            <b-form-input
                                id="cvvcodeInput"
                                placeholder="Código CVV"
                            ></b-form-input>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </form>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-6">
                <button
                    @click="activeTab = 0"
                    class="btn text-muted d-none d-sm-inline-block btn-link"
                >
                  <i class="mdi mdi-arrow-left me-1"></i> Voltar
                </button>
              </div>
              <!-- end col -->
              <div class="col-sm-6">
                <div class="text-end">
                  <button
                      @click="activeTab = 2"
                      class="btn btn-success"
                  >
                    <i class="mdi mdi-arrow-right me-1"></i> Avançar para Confirmação
                  </button>
                </div>
              </div>
              <!-- end col -->
            </div>
          </b-card-text>
        </b-tab>
        <b-tab>
          <template v-slot:title>
            <i class="bx bx-badge-check d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">Confirmação</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="card shadow-none border mb-0">
                  <div class="card-body">
                    <h4 class="card-title mb-4">Resumo de Pedido</h4>

                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">Produto</th>
                          <th scope="col">Descrição</th>
                          <th scope="col" class="text-end">Valor</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                          <th scope="row">
                            <img
                                src="@/assets/images/product/img-1.png"
                                alt="product-img"
                                title="product-img"
                                class="avatar-md"
                            />
                          </th>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <router-link
                                  to="/ecommerce/product-detail"
                                  class="text-dark"
                              >Produto Testes 0099</router-link
                              >
                            </h5>
                            <p class="text-muted mb-0">R$ 450,00 x 1</p>
                          </td>
                          <td class="float-end">R$ 450,00</td>
                        </tr>
                        <tr>
                          <th scope="row">
                            <img
                                src="@/assets/images/product/img-7.png"
                                alt="product-img"
                                title="product-img"
                                class="avatar-md"
                            />
                          </th>
                          <td>
                            <h5 class="font-size-14 text-truncate">
                              <router-link
                                  to="/ecommerce/product-detail"
                                  class="text-dark"
                              >Produto Testes 0077</router-link
                              >
                            </h5>
                            <p class="text-muted mb-0">R$ 225,00 x 1</p>
                          </td>
                          <td class="float-end">R$ 225,00</td>
                        </tr>
                        <tr>
                          <td colspan="2">
                            <h6 class="m-0 text-end">Sub Total</h6>
                          </td>
                          <td class="float-end">R$ 675,00</td>
                        </tr>
                        <tr>
                          <td colspan="3">
                            <div class="bg-soft bg-primary p-3 rounded">
                              <h5 class="font-size-14 text-primary mb-0">
                                <i class="fas fa-shipping-fast me-2"></i>
                                Frete
                                <span class="float-end">Grátis</span>
                              </h5>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td colspan="2">
                            <h6 class="m-0 text-end">Total</h6>
                          </td>
                          <td class="float-end">R$ 675,00</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-sm-6">
                <button
                    @click="activeTab = 1"
                    class="btn text-muted d-none d-sm-inline-block btn-link"
                >
                  <i class="mdi mdi-arrow-left me-1"></i> Voltar
                </button>
              </div>
              <!-- end col -->
              <div class="col-sm-6">
                <div class="text-end">
                  <router-link
                      to="/pedidos/list"
                      class="btn btn-success"
                  >
                    <i class="mdi mdi-rocket-launch me-1"></i> Confirmar Pedido
                  </router-link>
                </div>
              </div>
              <!-- end col -->
            </div>
          </b-card-text>
        </b-tab>
      </b-tabs>
    </div>
  </Layout>
</template>
